import * as React from 'react';
import styled from 'styled-components';
import { Box, Card, CardContent } from '@mui/material';
import { Col, Flex } from 'antd';
import { OtherCardItemType } from '../../../../common/types';
import { fonts } from '../../assets/constStyles';
import { SpanCaptionStyled } from './ProjectCardItem';

// const FlexStyled = styled(Flex)`
//   //width: 500px;
//   //width: 30%;
//   //flex-direction: column;
//   //flex: 1;
//
//   .ant-image{
//     width: 100%;
//     height: 100%;
//   }
//
//   .ant-image-img {
//     width: 100%;
//     height: 100%;
//   }
// `;

const CardStyled = styled(Card)`
  height: 100%;
  box-shadow: rgba(145, 158, 171, 0.3) 0 0 2px 0, rgba(145, 158, 171, 0.12) 0 12px 24px -4px;
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0;
  
  && * {
    font-family: ${fonts.font2} !important;
  }
`;

const TextStyled = styled.p`
  font-size: 1.5em;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 1.1em;
  }
`;

const TextCatStyled = styled.p`
  font-size: 1.5em;
  font-weight: 600;
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: 1.1em;
  }
`;

const TextDescriptionStyled = styled.p`
  font-size: 18px;
  text-align: justify;
`;

const FlexCardHeader = styled(Flex)`
  flex-direction: column;
  padding: 16px;
`;

interface OtherCardItemProps {
  dataCard: OtherCardItemType,
  images?: any
}

export const OtherCardItem: React.FC<OtherCardItemProps> = ({ dataCard, images }) => (
    <Col xs={24} sm={12}>
        <CardStyled variant="outlined" >
            <FlexCardHeader>
                <Flex align={'baseline'} gap={5} justify={'flex-end'}>
                    <SpanCaptionStyled>Year: </SpanCaptionStyled>
                    <TextStyled>{dataCard.year}</TextStyled>
                </Flex>
                <Flex align={'baseline'} gap={5}>
                    <TextCatStyled>{dataCard.award}</TextCatStyled>
                </Flex>
            </FlexCardHeader>
            <Box
                sx={{
                  width: '100%',
                  height: 400,
                  position: 'relative',
                  overflow: 'hidden',
                }}
            >
                <Box
                    component="img"
                    src={images}
                    alt="award"
                    sx={{
                      position: 'absolute',
                      top: '-1px',
                      left: 0,
                      width: '100%',
                      height: 'calc(100% + 1px)',
                      objectFit: 'cover',
                      display: 'block',
                    }}
                />
            </Box>
             {/* <CardMedia */}
             {/*   component="img" */}
             {/*   height="400" */}
             {/*   image={images} */}
             {/*   alt="award" */}
             {/*   style={{ display: 'block', padding: 0 }} */}
             {/* /> */}
            <CardContent style={{ flexGrow: 1 }}>
                <TextDescriptionStyled>{dataCard.description}</TextDescriptionStyled>
            </CardContent>
        </CardStyled>
    </Col>
);
